// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "faf08be32cbda1b98aeb6d0fba3ec6b7cf32394b/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};